import { ApiTenant, bffFetcher } from '@utils/api';
import BFFApi from "@utils/bffApi";

export default class CampaignService {
  static getCampaign(id) {
    return ApiTenant.get(`/incentivecampaign/1.0/campaign/${id}`);
  }

  static getCampaignReport(id) {
    return ApiTenant.get(`/incentivecampaign/1.0/report?incentive_campaign_id=${id}`);
  }

  static getCampaignFinancialMetrics(id) {
    return bffFetcher(`/api/v1/incentivecampaign/report/insights/${id}`);
  }

  static getCampaignFeed({ id, unitId, status }, next) {
    let URL = `/api/v1/incentivecampaign/units/post-info?incentive_campaign_id=${id}`;
    if (unitId) URL += `&unit_id=${unitId}`;
    if (status) URL += `&ad_status=${status}`;
    if (next) URL += `&page_hash=${String(next)}`;
    return bffFetcher(URL);
  }

  static createCampaign(body){
    return BFFApi.post(`/api/v1/incentivecampaign`, body)
  }
}
